import { FC } from 'react'

import { ExpandableCommentText } from '@/features/view-tfl-uploaded/components/CommentSidebar/ExpandableCommentText'

interface CommentCellProps {
  content: string
}

export const CommentCell: FC<CommentCellProps> = ({ content }) => {
  return (
    <div className="w-full">
      <ExpandableCommentText content={content} measureWithMentions />
    </div>
  )
}
